import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { Button } from "@gravity-ui/uikit";
import { RoutesList } from "@/router/routesList";
import { useSetPageData } from "@/tools/hooks";
export var ManagePage = function () {
    var navigate = useNavigate();
    useSetPageData({ title: "Управление" });
    return (_jsxs("div", { children: [_jsx(Button, { size: "l", onClick: function () {
                    navigate(RoutesList.Manage.getSportsList());
                }, children: "\u0412\u0438\u0434\u044B \u0441\u043F\u043E\u0440\u0442\u0430" }), _jsx(Button, { size: "l", onClick: function () {
                    navigate(RoutesList.Manage.getCitiesList());
                }, children: "\u0413\u043E\u0440\u043E\u0434\u0430" }), _jsx(Button, { size: "l", onClick: function () {
                    navigate(RoutesList.Place.getPlaceAdd());
                }, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0443" })] }));
};
